// extracted by mini-css-extract-plugin
export default {"formContainer":"style_formContainer__I7rKD","formGroup":"style_formGroup__pXjeV","title":"style_title__DOspo","btn":"style_btn__A4lZU"};